import * as api from 'api'
import { normalize } from 'normalizr'
import { Customer } from 'api/schema'
import { setEntities } from 'actions'

export const getCustomer = (customerId) => (dispatch) =>
  api
    .getCustomer(customerId)
    .then((response) => {
      const normalizedData = normalize(response.data, Customer)
      dispatch(setEntities(normalizedData.entities))
      return response.data
    })
    .catch((error) => {
      console.error('[ACTION](getCustomer) failed to run')
      throw error
    })



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/async/customer.js